import script from "./gamePage.vue?vue&type=script&setup=true&lang=js"
export * from "./gamePage.vue?vue&type=script&setup=true&lang=js"

import "./gamePage.vue?vue&type=style&index=0&id=37bc68a3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37bc68a3"]])

export default __exports__